export default class RecoverySuccessController {
  constructor() { }
}

 RecoverySuccessController.$inject = [];



// WEBPACK FOOTER //
// ./src/app/pages/recovery-success/recovery-success.controller.js